<template>
  <ReportTableWithHeader
    :loading="isLoading"
    :downloading="isDownloading"
    :rows="rows"
    :columns="columns"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    downloadable
    :type="reportType"
    :form="form"
    @onFilter="onFilter"
    @onPageChange="onPageChange"
    @onPerPageChange="onPerPageChange"
    @onDownload="onDownload"
  />
</template>

<script>
import reportTableMixin from '@/mixins/reportTableMixin';

export default {
  mixins: [reportTableMixin],

  data() {
    return {
      columns: [
        { field: 'userName' },
        { field: 'userRegister' },
        { field: 'currency' },
        { field: 'productName' },
        { field: 'createdAt' },
        { field: 'endDate' },
        { field: 'purpose' },
        { field: 'account' },
        { field: 'interestRate' },
        { field: 'amount' },
        { field: 'amount' },
        { field: 'officerName' },
        { field: 'firstOfficerName' },
      ],
      reportType: 'loan',
    };
  },

  methods: {
    updateFilters(data) {
      data.filters[`filter[reportType]`] = this.reportType;
    },
  },
};
</script>
